<template>
  <div class="try-on-usage-page">
    <h1>AI试衣使用数据</h1>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <table class="data-table">
      <thead>
        <tr>
          <th>时间</th>
          <th>任务</th>
          <th>用户</th>
          <th>商品</th>
          <th>模型</th>
          <th>状态</th>
          <th>耗时</th>
          <th>失败原因</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in usage" :key="item.id">
          <td>{{ formatDate(item.createdAt) }}</td>
          <td>{{ item.taskId }}</td>
          <td>{{ item.customerUsername || item.customerId }}</td>
          <td>{{ item.productName || item.productId }}</td>
          <td>{{ item.modelCode }}</td>
          <td>{{ item.status }}</td>
          <td>{{ item.durationMs || 0 }}ms</td>
          <td>{{ item.failureReason || '-' }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="usage.length === 0" class="empty">暂无AI试衣调用数据</div>
  </div>
</template>

<script>
export default {
  name: 'TryOnUsageStats',
  data() {
    return {
      usage: [],
      error: ''
    }
  },
  mounted() {
    this.loadUsage()
  },
  methods: {
    async loadUsage() {
      try {
        const response = await fetch('/api/admin/try-on/usage', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('sellerToken') || ''}`
          }
        })
        if (!response.ok) throw new Error('获取AI试衣使用数据失败')
        this.usage = await response.json()
      } catch (err) {
        this.error = err.message
      }
    },
    formatDate(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString()
    }
  }
}
</script>

<style scoped>
.try-on-usage-page {
  padding: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  border-bottom: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.alert {
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 4px;
}

.alert-danger {
  color: #721c24;
  background: #f8d7da;
}

.empty {
  padding: 20px;
  color: #666;
  text-align: center;
}
</style>
